import React from 'react';
import {LayerContainerProps} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import styled from 'styled-components';
import {Breakpoints, CTA} from '@volkswagen-onehub/components-core';
import {Close} from '@volkswagen-onehub/icons-core';
import {BrandThemeProvider} from '../theme';

export function LayerContainer({
  children,
  headline,
  closeButtonAriaLabel,
  closeLayer,
  closeButtonTestId,
}: LayerContainerProps): JSX.Element {
  return (
    <BrandThemeProvider theme="main">
      <section>
        <StyledHeader headline={headline} withCloseButton>
          {headline && (
            <StyledHeadlineWrapper>{headline}</StyledHeadlineWrapper>
          )}

          <StyledCloseButtonWrapper>
            <CTA
              tag="button"
              type="button"
              emphasis="tertiary"
              onClick={closeLayer}
              icon={<Close title={closeButtonAriaLabel} />}
              data-testid={closeButtonTestId}
            />
          </StyledCloseButtonWrapper>
        </StyledHeader>
        <LayerContent>{children}</LayerContent>
      </section>
    </BrandThemeProvider>
  );
}

const StyledHeadlineWrapper = styled.div`
  padding: ${(props) => props.theme.size.static150} 0;

  @media (min-width: ${Breakpoints.b560}px) {
    padding: ${(props) => props.theme.size.static250} 0;
  }
`;

const StyledCloseButtonWrapper = styled.div`
  flex-grow: 0;
  margin-inline-start: ${(props) => props.theme.size.grid001};
`;

const StyledHeader = styled.header<{
  withCloseButton: boolean;
  headline: React.ReactNode;
}>`
  display: flex;
  position: sticky;
  z-index: 1;
  top: 0;
  justify-content: ${(props) =>
    props.headline ? 'space-between' : 'flex-end'};
  padding-block: ${(props) => props.theme.size.static150}
    ${(props) => props.theme.size.static150};
  padding-inline: ${(props) => props.theme.size.grid001}
    ${(props) =>
      props.withCloseButton
        ? props.theme.size.static150
        : props.theme.size.grid001};
  background-color: ${(props) => props.theme.colors.background.backgroundColor};
`;

const LayerContent = styled.div`
  padding: 0 ${(props) => props.theme.size.grid001};
  padding-bottom: ${(props) => props.theme.size.static250};
  overflow-x: auto;

  @media (min-width: ${Breakpoints.b560}px) {
    padding-bottom: ${(props) => props.theme.size.static350};
  }
`;
